/**
 * @typedef {(value: string, targetPassword: string, errorMessage: string) => boolean | typeof errorMessage} AssertPasswordMatcher
 */

/**
 *
 * @type {AssertPasswordMatcher}
 */
export const assertPasswordMatch = (value, targetPassword, errorMessage) => {
  return !(value?.length > targetPassword.length) && value?.length < 8 ? false : value === targetPassword ? true : errorMessage;
};